import type { ReactNode } from 'react'
import { useFieldContext } from '@/lib/form-contexts'
import { cn } from '@/lib/utils'
import { Label } from '../ui/label'
import { Switch, type SwitchProps } from '../ui/switch'
import FieldInfo from './FieldInfo'
import { useIsReadOnly } from '@/lib/casl'

export type SwitchInputProps = SwitchProps & {
  label?: ReactNode
  description?: ReactNode
}

export default function SwitchInput({
  id,
  label = '',
  description = '',
  className = '',
  checked,
  ...props
}: SwitchInputProps) {
  const field = useFieldContext<boolean>()
  const { isReadOnly } = useIsReadOnly()

  return (
    <div className={cn('flex flex-col gap-y-2 w-full', className)}>
      <div className="inline-flex items-center gap-2">
        <Switch
          id={id || field.name}
          name={field.name}
          checked={checked ?? field.state.value}
          onCheckedChange={(isChecked) => field.handleChange(isChecked)}
          disabled={isReadOnly}
          {...props}
        />
        <div className="flex flex-col">
          <Label htmlFor={id || field.name}>{label}</Label>
          {!!description && <p className="mt-1.5 text-sm text-muted-foreground">{description}</p>}
        </div>
      </div>
      <FieldInfo />
    </div>
  )
}
